import clientService from '.';

const fetchQuery = async ({ url, method = 'GET', data, params }) => {
  try {
    const result = await clientService({
      url,
      method,
      data,
      params,
    });
    return { data: result };
  } catch (axiosError) {
    let err = axiosError.response ? axiosError.response : axiosError;
    return {
      error: {
        status: err.status || 'FETCH_ERROR',
        data: err.data || err.message,
      },
    };
  }
};

export default fetchQuery;
